import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./EventSection.css";

import img1 from "../images/img72.jpg";
import img2 from "../images/img73.jpg";
import img3 from "../images/img74.jpg";
import img4 from "../images/img75.jpg";
import img5 from "../images/img76.jpg";
import img6 from "../images/img77.jpg";
import img7 from "../images/img78.jpg";
import img8 from "../images/img7.jpg";
import img9 from "../images/img8.jpg";
import img10 from "../images/img9.jpg";
import img11 from "../images/img29.jpg";
import img12 from "../images/img34.jpg";

const eventsData = [
  {
    title: "ग्रंथ दिंडी उपक्रम",
    images: [img1, img2, img3],
    date: "18-01-2026",
    description:
      "ग्रंथ दिंडी उपक्रम मोठ्या उत्साहात पार पडला. वाचनसंस्कृतीचा प्रसार व ज्ञानाचे महत्त्व समाजापर्यंत पोहोचवण्यासाठी विद्यार्थी व नागरिकांनी सहभाग घेत जनजागृती केली.",
  },
  {
    title: "कोडोली ग्रामपंचायतीतर्फे ग्रंथ पूजन",
    images: [img4, img5, img6, img7],
    date: "30-01-2025",
    description:
      "कोडोली ग्रामपंचायतीतर्फे ग्रंथ पूजन सोहळा श्रद्धा व उत्साहात संपन्न झाला. ज्ञानसंवर्धन व वाचनसंस्कृतीच्या जतनासाठी या उपक्रमाचे आयोजन करण्यात आले असून ग्रामस्थांनी उत्स्फूर्त सहभाग नोंदविला.",
  },
  {
    title: "नारीशक्ती सन्मान सोहळा",
    images: [img8, img9, img10],
    date: "30-01-2025",
    description:
      "नवरात्रोत्सवानिमित्त आयोजित हळदी-कुंकू व नारीशक्ती सन्मान सोहळ्याच्या प्रसंगी मा. पूनमजी महाजन ताईं यांच्या हस्ते दीपप्रज्वलन करण्यात आले.",
  },
  {
    title: "वृक्षारोपण कार्यक्रम",
    images: [img11, img12, img11],
    date: "05-02-2025",
    description:
      "जागतिक पर्यावरण दिनानिमित्त वृक्षारोपण कार्यक्रम उत्साहात पार पडला. पर्यावरण संवर्धनाचा संदेश देत मोठ्या संख्येने नागरिकांनी या उपक्रमात सहभाग नोंदविला.",
  },
];

const EventsSection = () => {
  const sectionRef = useRef(null);
  const navigate = useNavigate(); // ✅ इथे ठेवा

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sectionRef.current.classList.add("show");
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="events-section" ref={sectionRef}>
      <h2 className="events-title">“नवीन उपक्रम आणि कार्यक्रम”</h2>

      <div className="events-grid">
        {eventsData.map((event, index) => (
          <div className="event-card" key={index}>
            {/* IMAGE SLIDER */}
            <div className="event-image">
              <div className="image-slider">
                {event.images.map((img, i) => (
                  <img src={img} alt="कार्यक्रम" key={i} />
                ))}
              </div>
            </div>

            {/* CONTENT */}
            <div className="event-content">
              <h3 className="event-title">{event.title}</h3>
              <div className="event-date">
                <span>📅</span> {event.date}
              </div>
              <p>{event.description}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="events-btn-wrapper">
        <button
          className="events-btn"
          onClick={() => navigate("/events")} // ✅ EventGallery page चा route
        >
          सर्व उपक्रम पहा
        </button>
      </div>
    </section>
  );
};

export default EventsSection;